import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`The User Object`}</h2>
    <p>{`The User Object contains information about the user associated with a GIF and URLs to assets such as that user's avatar image, GIPHY profile, and more.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`avatar_url:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The URL for this user's avatar image.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/avatars/election2016/XwYrZi5H87o6.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`banner_url:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The URL for the banner image that appears atop this user's profile page.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media4.giphy.com/avatars/cheezburger/XkuejOhoGLE6.jpg"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`profile_url:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The URL for this user's GIPHY profile.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://giphy.com/cheezburger/"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`username:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The username associated with this user.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"joecool4000"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`display_name:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The display name associated with this user (contains formatting the base username might not).`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"JoeCool4000"`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      